<script lang="ts">
export const radioCls = cva("radio duration-150 before:duration-150", {
	variants: {
		color: {
			default: null,
			neutral: "radio-neutral",
			primary: "radio-primary",
			secondary: "radio-secondary",
			accent: "radio-accent",
			info: "radio-info",
			warning: "radio-warning",
			error: "radio-error",
		},
		size: {
			xs: "radio-xs",
			sm: "radio-sm",
			md: "radio-md",
			lg: "radio-lg",
		},
	},
});

type _props = VariantProps<typeof radioCls>;

export interface RadioProps extends ClassProps, DeprecatedSizeProps, RadioGroupItemProps {
	color?: _props["color"];
	size?: _props["size"];
}
</script>

<script setup lang="ts">
import { cva, type VariantProps } from "class-variance-authority";
import { RadioGroupItem, useForwardProps, type RadioGroupItemProps } from "reka-ui";
import { computed } from "vue";
import { useDelegatedProps, type ClassProps } from "../../lib/base-props";
import { allSize, convertDeprecatedSize, type DeprecatedSizeProps } from "../../lib/size";
import { cn } from "../../lib/utils";

const props = defineProps<RadioProps>();

const delegatedProps = useDelegatedProps(props, ["color", "size", ...allSize]);

const forwarded = useForwardProps(delegatedProps);

const size = computed(() => {
	if (props.size != null) {
		return props.size;
	}

	return convertDeprecatedSize(props);
});
</script>

<template>
	<RadioGroupItem :class="cn(radioCls({ ...props, size }))" v-bind="forwarded" />
</template>
